import { Outlet, useLocation } from "react-router-dom";
import BottleNecks from "./components/BookDemo/BottleNecks";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";

const Layout = () => {
  const location = useLocation();
  return (
    <div>
      <Navbar />
      <Outlet />
      {!location?.pathname?.includes("contact") ? <BottleNecks /> : null}
      <Footer />
    </div>
  );
};

export default Layout;
